export default "__VITE_ASSET__34bcb36e__"